import * as React from 'react';

function ManagementScore({data} :any) {
  return (
    <div className="col-md-4 stretch-card grid-margin">
      <div className={`card card-img-holder text-white ${data.management_score_color}`}>
        <div className="card-body">
          <h4 className="font-weight-normal mb-3">Management Score<i className="mdi mdi-bookmark-outline mdi-24px float-right"></i>
          </h4>
          <h2 className="mb-5">{data.management_score}%</h2>
          <h6 className="card-text">{data.management_score_meaning}</h6>
        </div>
      </div>
    </div>
  );
}

export default ManagementScore;
